import { gql } from '@apollo/client';

export const GET_COUNT_QUERY = gql`
  query GetCountQuery($filters: String!) {
    getCount(filters: $filters)
  }
`;

// ATAD-134. Approximate size of the US consumer universe, read from a server
// env var — not a live count. Only used as a denominator to tell "half the
// country" from a normal audience, so an estimate is enough.
export const AUDIENCE_UNIVERSE_SIZE_QUERY = gql`
  query AudienceUniverseSizeQuery {
    audienceUniverseSize
  }
`;

export const AUDIENCES_QUERY = gql`
  query AudiencesQuery {
    audiences {
      id
      name
      recordsAvailable
      recordsIncluded
      updatedAt
      crawledAt
      crawlingFailed
    }
  }
`;

export const AUDIENCE_QUERY = gql`
  query AudienceQuery($audienceName: String!) {
    audience(audienceName: $audienceName) {
      id
      name
      filters
      recordsAvailable
      recordsIncluded
      emailsAvailable
      emailsIncluded
      ipsAvailable
      ipsIncluded
      phonesAvailable
      phonesIncluded
      purchasedAt
      crawledAt
      # Distinguishes "still processing" from "preparation gave up", which the
      # UI previously showed identically. See ActionsDropdown.
      crawlingFailed
      crawlRetryCount
      updatedAt
    }
  }
`;

export const PURCHASED_AUDIENCES_QUERY = gql`
  query PurchasedAudiencesQuery {
    purchasedAudiences {
      id
      name
      recordsIncluded
      purchasedAt
      crawledAt
      crawlingFailed
      updatedAt
    }
  }
`;

export const PURCHASED_AUDIENCE_QUERY = gql`
  query PurchasedAudienceQuery($audienceName: String!) {
    purchasedAudience(audienceName: $audienceName) {
      downloadLink
    }
  }
`;

export const CITY_OPTIONS_QUERY = gql`
  query CityOptionsQuery($query: String!) {
    cityOptions(query: $query)
  }
`;
